import React from 'react';
import Tag from '../../../../../../muiComponents/Tag';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../../customHooks/useTranslate';
import useLanguage from '../../../../../../customHooks/useLanguage';
import { formatUTCDateTime } from '../../../../../../utils/formatDates';
import { AgencyConnectionState } from '../../../../types/zitoneoServicesTypes';

interface ConnectivityLogsAgenciesPreviewProps {
    agencies: AgencyConnectionState[];
    onOpenPanel: () => void;
}

const ConnectivityLogsAgenciesPreview = ({
    agencies,
    onOpenPanel,
}: ConnectivityLogsAgenciesPreviewProps) => {
    const translate = useTranslate();
    const language = useLanguage();

    return (
        <ul className='activity-logs-summary__list'>
            {agencies.map(({ name, failed, lastConnection }, index) =>
                failed ? (
                    <li key={name + index}>
                        <Tooltip
                            title={`${translate(
                                'last_connection_failed'
                            )} ${formatUTCDateTime(
                                lastConnection,
                                language
                            )}. ${translate('click_to_see_more_details')}`}
                        >
                            <div
                                className='cursor-pointer'
                                onClick={onOpenPanel}
                            >
                                <Tag
                                    text={name}
                                    variant='surface'
                                    color='red'
                                    className='agency-tag'
                                />
                            </div>
                        </Tooltip>
                    </li>
                ) : (
                    <li key={name + index}>
                        <Tag
                            text={name}
                            variant='surface'
                            color='grey'
                            className='agency-tag'
                        />
                    </li>
                )
            )}
        </ul>
    );
};

export default ConnectivityLogsAgenciesPreview;
